<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <div class="mb-6">
          <section class="mb-4 flex justify-start gap-1">
            <h6><strong>Nama Pemilik Kode</strong></h6>
            <span class="text-danger">*</span>
          </section>
          <vs-input
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="referal's name"
            class="w-full sidebar-input"
            v-model="formData.name"
            placeholder="Isi Dengan Nama Pemilik Kode Referal"
          />
          <span class="text-danger text-sm">{{ errors.first("referal's name") }}</span>
        </div>
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Sosial Media</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="['Facebook', 'Twitter', 'Instagram', 'Tiktok', 'WhatsApp']"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="social media"
          v-model="formData.sosmed"
          placeholder="Pilih Sosial Media"
        />
        <span class="text-danger text-sm">{{ errors.first("social media") }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addData"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  components: {
    flatPickr,
  },
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      emptyImage,
      url,
      formData: {
        user_id: null,
        name: "",
        sosmed: "",
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Kode Referal" : "Tambah Kode Referal";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      return (
        !this.errors.any() && this.formData.name !== "" && this.formData.sosmed !== ""
      );
    },
    sosmeds() {
      return this.$store.state.medsos.medsosList;
    },
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
    katSelect() {
      return this.formData.kat_id;
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.user_id = this.passData.user.id;
        this.formData.name = this.passData.name;
        this.formData.sosmed = this.passData.sosmed;
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.formData.user_id = null;
      this.formData.name = "";
      this.formData.sosmed = "";
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }

      // if (this.checkCategory) {
      //   this.formData.kat_id = this.$store.state.zis.kategoriList.find(
      //     (v) => v.name === "Zakat" || v.name === "Zakat Fitrah"
      //   ).id;
      //   this.formData.sub_id = this.$store.state.zis.subKategoriList.find(
      //     (v) => v.name === "Zakat Fitrah"
      //   ).id;
      // }
      this.formData.user_id = this.profile.id;
      this.$store
        .dispatch("referal/cudReferal", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null ? "Edit Referal Sukses!" : "Tambah Referal Sukses!",
            text:
              this.passData !== null
                ? `Referal ${v.name} Berhasil diedit`
                : `Referal ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
  },
};
</script>

<style scoped>
.text-red {
  color: red;
}
.text-blue {
  color: blue;
}
.text-grey-black {
  color: rgb(70, 70, 70);
}
img {
  max-height: 400px;
  overflow: auto;
}
</style>
